import Navbar from "../components/Navbar";
import { Layout } from "antd";
import PeriodicTable from "../components/PeriodicTable";
function FLashcard(){
    
    return(
        <Layout>
        <Navbar/>
        <PeriodicTable/>
        </Layout>
    )
}
export default FLashcard;